import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({y: 0}),
  /**
   * base 配置访问域名二级目录
   * 读取项目根路径vue.config.js
   * */
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: resolve => require(['@/pages/login'], resolve)
    },
    {
      path: '/main',
      name: 'Main',
      component: resolve => require(['@/pages/main'], resolve),
      children: []
    },
  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({name: from.name}) : next('/')
  } else if (to.name !== 'Login') {
    // if (localStorage.token) {
    next()
    // } else {
    //   localStorage.clear()
    //   next({path: '/'})
    // }
  } else {
    next()
  }
})

export default router
